import styled from 'styled-components';
import { colors } from '../styles/variables';

const InventoryCartItemView = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.white};
  padding: 8px 16px;
  line-height: 1.2em;
  border-bottom: 1px solid ${colors.gray200};
  &:last-of-type {
    border-bottom: 0;
  }
  p {
    font-size: 12px;
    margin-bottom: 0;
  }
  .date {
    font-size: 12px;
  }
  .mute {
    font-size: 10px;
    color: ${colors.gray600};
    span, strong {
      margin-right: 8px;
    }
  }
`;

export default InventoryCartItemView;
